






















































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { FormulasApi, Formula, Audit } from '@/api';
import infoTabs from '@/layouts/parent/BTabsParent.vue';

@Component({
	components: {
		secondaryNav,
		infoTabs,
	},
})
export default class FormulaView extends Vue {
	public loading = true;

	public audits: Audit[] | null = null;
	public formula: Formula | null = null;

	public formulaFields: any[] | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
	];

	public auditFields: any[] | null = [
		{ key: 'created_at', label: 'Date Updated' },
		{ key: 'fields', label: 'Fields' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
	private api: FormulasApi;

	constructor() {
		super();
		this.api = new FormulasApi();
	}

	public async load() {
		const { formulaId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getFormulaById(parseInt(formulaId, 10), {
				params: {
					include: 'audits,audits.user',
				},
			});
			this.formula = data;
			this.audits = data.audits;
		} catch (e) {
			this.formula = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
